














































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import BreadcrumbComponent from '@/_shared/components/layout/breadcrumb.component.vue';
import ClubsEnum from '@/achieve/enums/annual-recognition/clubs.enum';
import RecognitionClub from '@/achieve/components/annual-recognition/recognition-club.component.vue';
import invert from 'lodash/invert';

@Component({
  components: {
    BreadcrumbComponent,
    RecognitionClub,
  },
})
export default class AnnualRecognitionView extends Vue {
  selectedTab = 0;
  tabs = [ClubsEnum.CLUB_MILLION, ClubsEnum.CLUB_500K, ClubsEnum.CLUB_250K];
  lazyLoadedTabs = new Set<string>([ClubsEnum.CLUB_MILLION]);

  getTabTitle(tab: string): string {
    const clubsEnum: Record<string, string> = invert(ClubsEnum);
    return `DEVELOPMENTOR.MENU.ANNUAL_RECOGNITION.${clubsEnum[tab]}`;
  }

  isTabNotLazyLoaded(tab: string): boolean {
    return !this.lazyLoadedTabs.has(tab);
  }

  addLazyLoadedTab(tab: string): void {
    this.lazyLoadedTabs.add(tab);
    this.$forceUpdate();
  }

  selectTab(tab: number) {
    this.selectedTab = tab;
    this.addLazyLoadedTab(this.tabs[tab]);
  }
}
